import Button from "../../../../components/button/Button";
import CloseButton from "../../../../components/closeButton/CloseButton";
import WarningIcon from "../../../../components/icons/WarningIcon";
import useTranslation from "../../../../hooks/i18n/useTranslation";
import "./PatientMetadataMismatchModal.css";

const formatFullName = (firstName, lastName, fallback) => {
  const fullName = [firstName, lastName].filter(Boolean).join(" ").trim();
  return fullName || fallback;
};

const PatientMetadataMismatchModal = ({
  patientName,
  mismatchSubject,
  onClose,
  onContinue,
}) => {
  const { t } = useTranslation();

  const importedSubjectName = formatFullName(
    mismatchSubject?.firstName,
    mismatchSubject?.lastName,
    t("482")
  );

  return (
    <div className="patient-metadata-mismatch-overlay">
      <div className="patient-metadata-mismatch-modal">
        <CloseButton onClose={onClose} tooltip={t("43")} />
        <div className="patient-metadata-mismatch-header">
          <WarningIcon />
          <h2 className="patient-metadata-mismatch-title">{t("480")}</h2>
        </div>
        <div className="patient-metadata-mismatch-body">
          <p className="patient-metadata-mismatch-message">
            {t("481")} <strong>{importedSubjectName}</strong> {t("483")}{" "}
            <strong>{patientName}</strong>.
          </p>
          <p className="patient-metadata-mismatch-submessage">{t("484")}</p>
        </div>
        <div className="patient-metadata-mismatch-actions">
          <Button value={t("471")} onClick={onContinue} />
        </div>
      </div>
    </div>
  );
};

export default PatientMetadataMismatchModal;
